import {
  useFetchCollCalcTimeNoSuspense,
  useFetchDatamartTimeNoSuspense,
  useFetchLegalEntityTime,
  useFetchLifeTimeNoSuspense,
  useFetchMoneyInTime,
  useFetchMoneyOutTime,
  useFetchUnitlinkTimeNoSuspense,
} from '@festina-life/api'
import { notEmpty, type Optional } from '@festina-life/core'

import { useAvailableComponentsForTenant } from './useAvailableComponentsForTenant'
import { useTime } from './useTime'

type SystemTime = {
  name: string
  time: Optional<string>
}

export const useTimes = () => {
  const { data: time } = useTime()
  const {
    isUsingCollCalc,
    isUsingDatamart,
    isUsingLegalEntity,
    isUsingLife,
    isUsingMoneyIn,
    isUsingMoneyOut,
    isUsingUnitLink,
  } = useAvailableComponentsForTenant()

  const { data: lifeTime } = useFetchLifeTimeNoSuspense(
    {},
    { enabled: !!isUsingLife },
  )
  const { data: legalEntityTime } = useFetchLegalEntityTime(
    {},
    { enabled: !!isUsingLegalEntity },
  )
  const { data: moneyInTime } = useFetchMoneyInTime(
    {},
    { enabled: !!isUsingMoneyIn },
  )
  const { data: moneyOutTime } = useFetchMoneyOutTime(
    {},
    { enabled: !!isUsingMoneyOut },
  )
  const { data: unitLinkTime } = useFetchUnitlinkTimeNoSuspense(
    {},
    { enabled: !!isUsingUnitLink },
  )
  const { data: collCalcTime } = useFetchCollCalcTimeNoSuspense(
    {},
    { enabled: !!isUsingCollCalc },
  )
  const { data: datamartTime } = useFetchDatamartTimeNoSuspense(
    {},
    { enabled: !!isUsingDatamart },
  )

  const componentTimes: SystemTime[] = [
    { name: 'Life', time: lifeTime },
    { name: 'Legal entity', time: legalEntityTime },
    { name: 'Money in', time: moneyInTime },
    { name: 'Money out', time: moneyOutTime },
    { name: 'Unit link', time: unitLinkTime },
    { name: 'Coll calc', time: collCalcTime },
    { name: 'Datamart', time: datamartTime },
  ]

  const allValidDates = componentTimes.filter(({ time }) => notEmpty(time))

  const areComponentTimesAllEqual = allValidDates.every(
    (t) => t === allValidDates[0],
  )

  const hasAnyValidTime = allValidDates.length > 0

  return { time, componentTimes, areComponentTimesAllEqual, hasAnyValidTime }
}
